import React from 'react';
import { Card } from './ui/card';
import { Factory, CheckCircle, Truck, Headphones } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ServicesSection = () => {
  const { t } = useLanguage();

  const services = [
    {
      id: 1,
      title: t.services.service1.title,
      description: t.services.service1.description,
      icon: Factory
    },
    {
      id: 2,
      title: t.services.service2.title,
      description: t.services.service2.description,
      icon: CheckCircle
    },
    {
      id: 3,
      title: t.services.service3.title,
      description: t.services.service3.description,
      icon: Truck
    },
    {
      id: 4,
      title: t.services.service4.title,
      description: t.services.service4.description,
      icon: Headphones
    }
  ];

  return (
    <section id="services" className="py-20 bg-gradient-to-b from-slate-50 to-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">{t.services.title}</h2>
          <div className="w-20 h-1 bg-teal-600 mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            {t.services.description}
          </p>
        </div>

        {/* Services Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {services.map((service) => {
            const IconComponent = service.icon;
            return (
              <Card
                key={service.id}
                className="p-8 text-center hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-0 shadow-md bg-white group"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-teal-100 to-teal-50 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform">
                  <IconComponent className="text-teal-600" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600 leading-relaxed">
                  {service.description}
                </p>
              </Card>
            );
          })}
        </div>

        {/* Additional Value Proposition */}
        <div className="mt-16 max-w-5xl mx-auto">
          <Card className="p-8 md:p-12 bg-gradient-to-br from-teal-600 to-teal-700 text-white border-0 shadow-xl">
            <div className="grid md:grid-cols-2 gap-8 items-center">
              <div>
                <h3 className="text-3xl font-bold mb-4">
                  {t.services.whyUs}
                </h3>
                <p className="text-teal-50 leading-relaxed mb-6">
                  {t.services.whyUsDesc}
                </p>
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold mb-1">%100</div>
                  <div className="text-sm text-teal-100">{t.services.quality}</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold mb-1">7/24</div>
                  <div className="text-sm text-teal-100">{t.services.support}</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold mb-1">15+</div>
                  <div className="text-sm text-teal-100">{t.services.exportCountries}</div>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4 text-center">
                  <div className="text-3xl font-bold mb-1">7000+</div>
                  <div className="text-sm text-teal-100">{t.services.capacity}</div>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
